import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrackingSection from '../home/components/TrackingSection';

export default function TrackingPage() {
  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      <Navbar />
      <div className="pt-16">
        {/* Page header */}
        <div className="bg-[#0D0D0D] py-20 px-6">
          <div className="max-w-7xl mx-auto">
            <span className="inline-block bg-[#FF6B35]/20 text-[#FF6B35] text-xs font-bold px-3 py-1 rounded-full mb-4 tracking-widest uppercase">
              Real-time Tracking
            </span>
            <h1 className="text-white font-black" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(40px, 6vw, 72px)', letterSpacing: '0.02em' }}>
              Track Your Order
            </h1>
            <p className="text-white/60 text-sm max-w-lg mt-2">
              Stay updated on your beverage delivery in real-time. From Georgetown stores to your doorstep.
            </p>
          </div>
        </div>
        <TrackingSection />
      </div>
      <Footer />
    </div>
  );
}
